/* AISTROWISE — Landing "Mapa del año" (CPL Swarmiz)
   Vanilla JS, zero deps (Cloudflare Turnstile loaded separately in the section).
   Config comes from data-* on #lp-root (written by Liquid section settings):
     data-webhook   -> n8n intake endpoint (empty/REPLACE_ME => simulate)
     data-sitekey   -> Cloudflare Turnstile site key (empty => skip challenge, preview only)
   Anti-bot sent to the server for authoritative checks: ts_token, elapsed_ms, hp. */
(function(){
  "use strict";

  var root = document.getElementById("lp-root");
  var WEBHOOK_URL = (root && root.getAttribute("data-webhook")) || "REPLACE_ME";
  var SITEKEY = (root && root.getAttribute("data-sitekey")) || "";

  var form = document.getElementById("lead-form");
  var card = document.getElementById("card");
  var btn = document.getElementById("submit-btn");
  var formError = document.getElementById("form-error");
  var loadTime = Date.now();
  var submitting = false;

  // URL params -> hidden fields
  try {
    var params = new URLSearchParams(window.location.search);
    document.getElementById("transaction_id").value = params.get("transaction_id") || "";
    document.getElementById("affid").value = params.get("affid") || params.get("affiliate_id") || "";
  } catch (e) {}

  // Build native date selects
  var elDia = document.getElementById("dia");
  var elMes = document.getElementById("mes");
  var elAno = document.getElementById("ano");
  var meses = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];
  function opt(value, label){ var o = document.createElement("option"); o.value = value; o.textContent = label; return o; }
  function ph(label){ var o = opt("", label); o.disabled = true; o.selected = true; return o; }
  elDia.appendChild(ph("día"));
  for (var d = 1; d <= 31; d++) elDia.appendChild(opt(String(d), String(d)));
  elMes.appendChild(ph("mes"));
  for (var m = 0; m < 12; m++) elMes.appendChild(opt(String(m + 1), meses[m]));
  elAno.appendChild(ph("año"));
  var maxYear = new Date().getFullYear() - 18;
  for (var y = maxYear; y >= 1930; y--) elAno.appendChild(opt(String(y), String(y)));

  // Starfield (full viewport)
  var starsEl = document.getElementById("stars");
  function makeStars(){
    if (!starsEl) return;
    var w = starsEl.clientWidth, h = starsEl.clientHeight;
    if (!w || !h) return;
    var n = Math.max(40, Math.min(120, Math.round(w * h / 6200)));
    var s = "";
    for (var i = 0; i < n; i++){
      s += '<circle cx="' + (Math.random()*w).toFixed(1) + '" cy="' + (Math.random()*h).toFixed(1) + '" r="' + (Math.random()*1.3+0.3).toFixed(2) + '" fill="#fff" opacity="' + (Math.random()*0.6+0.2).toFixed(2) + '"/>';
    }
    for (var j = 0; j < Math.round(n/12); j++){
      s += '<circle cx="' + (Math.random()*w).toFixed(1) + '" cy="' + (Math.random()*h).toFixed(1) + '" r="' + (Math.random()*1.3+1).toFixed(2) + '" fill="#D7D3FF" opacity="0.72"/>';
    }
    starsEl.innerHTML = '<svg width="'+w+'" height="'+h+'" viewBox="0 0 '+w+' '+h+'" preserveAspectRatio="none" style="position:absolute;inset:0;width:100%;height:100%">'+s+'</svg>';
  }
  makeStars();
  var rt; window.addEventListener("resize", function(){ clearTimeout(rt); rt = setTimeout(makeStars, 200); });

  // ── Validation ──────────────────────────────────────
  var nombre = document.getElementById("nombre");
  var email = document.getElementById("email");
  var cEmail = document.getElementById("consent_email");
  var cAge = document.getElementById("consent_age");
  function show(id, on){ document.getElementById(id).classList.toggle("show", on); }
  function invalid(el, on){ el.classList.toggle("is-invalid", on); el.setAttribute("aria-invalid", on ? "true" : "false"); }
  function emailOk(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); }
  function daysInMonth(mm, yy){ return new Date(yy, mm, 0).getDate(); }

  function vNombre(mark){ var ok = nombre.value.trim().length >= 2; if (mark !== false){ invalid(nombre, !ok); show("err-nombre", !ok);} return ok; }
  function vEmail(mark){ var ok = emailOk(email.value); if (mark !== false){ invalid(email, !ok); show("err-email", !ok);} return ok; }
  function vFecha(mark){
    var dd = elDia.value, mm = elMes.value, yy = elAno.value;
    var ok = !!(dd && mm && yy);
    if (ok) ok = (+dd) <= daysInMonth(+mm, +yy);
    if (mark !== false){
      [elDia, elMes, elAno].forEach(function(s){ s.classList.toggle("is-invalid", !ok); });
      show("err-fecha", !ok);
    }
    return ok;
  }
  function vEmailConsent(mark){ var ok = cEmail.checked; if (mark !== false){ show("err-consent_email", !ok); document.getElementById("check-email").classList.toggle("is-invalid", !ok);} return ok; }
  function vAge(mark){ var ok = cAge.checked; if (mark !== false){ show("err-consent_age", !ok); document.getElementById("check-age").classList.toggle("is-invalid", !ok);} return ok; }

  nombre.addEventListener("blur", function(){ vNombre(); });
  email.addEventListener("blur", function(){ vEmail(); });
  nombre.addEventListener("input", function(){ if (nombre.classList.contains("is-invalid")) vNombre(); });
  email.addEventListener("input", function(){ if (email.classList.contains("is-invalid")) vEmail(); });
  [elDia, elMes, elAno].forEach(function(s){
    s.addEventListener("change", function(){
      s.classList.toggle("is-empty", !s.value);
      if (document.getElementById("err-fecha").classList.contains("show")) vFecha();
    });
  });
  cEmail.addEventListener("change", function(){ vEmailConsent(); });
  cAge.addEventListener("change", function(){ vAge(); });

  // ── Turnstile token (single-use; reset after each POST attempt) ──
  function turnstileToken(){
    var el = form.querySelector('[name="cf-turnstile-response"]');
    return el ? el.value : "";
  }
  function resetTurnstile(){
    try { if (window.turnstile && typeof window.turnstile.reset === "function") window.turnstile.reset(); } catch (e) {}
  }

  function setPending(p){
    submitting = p;
    btn.disabled = p;
    btn.textContent = p ? "enviando…" : "Pide tu mapa del año";
  }
  function track(name){
    try { if (window.dataLayer) window.dataLayer.push({ event: name }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, {}); } catch (e) {}
  }
  function showSuccess(){
    card.innerHTML = document.getElementById("success-tpl").innerHTML;
    var h = card.querySelector("h2");
    if (h && h.focus) h.focus();
    track("lead_thankyou_view");
    var cta = card.querySelector(".success-cta");
    if (cta) cta.addEventListener("click", function(){ track("thankyou_softcta_click"); });
  }
  function fail(){ formError.hidden = false; setPending(false); resetTurnstile(); }

  form.addEventListener("submit", function(e){
    e.preventDefault();
    formError.hidden = true;

    // Anti-bot layer 1: honeypot -> fake success, no request
    var hp = form.querySelector('input[name="empresa"]');
    var hpVal = hp ? hp.value.trim() : "";
    if (hpVal !== ""){ showSuccess(); return; }
    // Anti-bot layer 2: minimum 3s on page (silent client gate; also re-checked server-side via elapsed_ms)
    var elapsed = Date.now() - loadTime;
    if (elapsed < 3000) return;

    var okN = vNombre(), okE = vEmail(), okF = vFecha(), okEC = vEmailConsent(), okA = vAge();
    if (!(okN && okE && okF && okEC && okA)){
      var first = form.querySelector(".is-invalid");
      if (first && first.focus) first.focus();
      return;
    }
    if (submitting) return;

    // Anti-bot layer 3: Cloudflare Turnstile token (verified server-side in n8n)
    var token = turnstileToken();
    if (SITEKEY && !token){
      formError.hidden = false;
      return; // challenge not solved yet; user can retry in a moment
    }

    var payload = {
      nombre: nombre.value.trim(),
      email: email.value.trim(),
      dia: elDia.value,
      mes: elMes.value,
      ano: elAno.value,
      transaction_id: document.getElementById("transaction_id").value,
      affid: document.getElementById("affid").value,
      consent: true,
      ts_token: token,
      elapsed_ms: elapsed,
      hp: hpVal
    };

    setPending(true);

    if (!WEBHOOK_URL || WEBHOOK_URL === "REPLACE_ME"){
      console.warn('[AISTROWISE] webhook sin configurar: se simula el envío. Configura la URL del webhook en los ajustes de la sección.');
      setTimeout(function(){ showSuccess(); }, 850);
      return;
    }

    fetch(WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function(res){
      if (res.ok){ showSuccess(); }
      else { fail(); }
    }).catch(function(){
      fail();
    });
  });
})();
